import { render, staticRenderFns } from "./indexSetting.vue?vue&type=template&id=70489781&scoped=true"
import script from "./indexSetting.vue?vue&type=script&lang=js"
export * from "./indexSetting.vue?vue&type=script&lang=js"
import style0 from "./indexSetting.vue?vue&type=style&index=0&id=70489781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70489781",
  null
  
)

export default component.exports